<template>
  <ElIcon :class="mode">
    <svg :style="iconStyle">
      <use :href="iconSymbolId" />
    </svg>
  </ElIcon>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { ElIcon } from 'element-plus'
import type { IconMode, IconSize } from '@/components/basic/types'


interface IconProps {
  icon: string
  mode?: IconMode
  size?: IconSize
}

const { icon, mode = 'current', size = 'default' } = defineProps<IconProps>()

const sizeMap: Record<IconSize, string> = {
  small: 'var(--ps-icon-size-s)',
  default: 'var(--ps-icon-size-m)',
  large: 'var(--ps-icon-size-l)',
  extraLarge: 'var(--ps-icon-size-xl)',
}

const iconSymbolId = computed(() => '#icon-' + icon)

const iconStyle = computed(() => ({
  width: sizeMap[size],
  height: sizeMap[size],
}))

</script>

<style scoped>
.current {
  fill: currentColor;
  stroke: currentColor;
}

.primary {
  fill: var(--ps-primary-text-color);
  stroke: var(--ps-primary-text-color);
}

.danger {
  fill: var(--ps-danger-text-color);
  stroke: var(--ps-danger-text-color);
}
</style>
